<div class="page">
  <app-nav-bar *ngIf="showNavBar" [showOrgSelect]="false" [showNavButtons]="false"></app-nav-bar>
  <div class="container">
    <app-large-cykubed-logo></app-large-cykubed-logo>
    <app-beta-message></app-beta-message>

  </div>
</div>
